import { Tooltip } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import { useMedplum } from '@medplum/react'
import { useConsentStatus } from './useConsentStatus'
import { downloadAttachmentFile } from '@/utils/downloadAttachment'
import { logError } from '@/utils/errorUtils'

// Patient-header consent status: green "Consent Signed" (+ download of the signed
// document) or red "Consent Not Signed". Plain text to match the patient header.
export const ConsentStatus = ({ patientId }: { patientId: string }) => {
  const medplum = useMedplum()
  const { signed, loading, attachment } = useConsentStatus(patientId)

  if (loading) return null

  if (!signed) {
    return <span className="text-xs font-semibold text-red-600">Consent Not Signed</span>
  }

  return (
    <div className="flex items-center gap-1">
      <span className="text-xs font-semibold text-green-600">Consent Signed</span>
      {attachment?.url && (
        <Tooltip label="Download signed consent" withArrow>
          <IconDownload
            size={14}
            stroke={2}
            className="cursor-pointer text-blue-600"
            aria-label="Download signed consent"
            onClick={() => {
              downloadAttachmentFile(
                medplum,
                attachment.url as string,
                attachment.title || 'consent',
              ).catch((err) => logError('ConsentStatus', 'download signed consent', err))
            }}
          />
        </Tooltip>
      )}
    </div>
  )
}
